/*!
* @copyright
* Copyright(c) 2018 SICK AG
*/
const style = `*:focus {
  outline: none;
}

/* default */
:host {
  font-size: 1rem;
  display: inline-block;
  vertical-align: middle;
  height: calc(46rem/14);
  width: 100%;
  max-width: calc(576rem/14);
  font-size: calc(14rem/14);
}
:host .container {
  height: 100%;
  text-decoration: none;
  background-color: #EEEFF0;
  background-color: var(--davinci-color-background-3, #EEEFF0);
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-content: flex-start;
  align-items: center;
}
:host .container .slotPlaceholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 0 1 auto;
}
:host .container .slotPlaceholder ::slotted(img) {
  height: calc(46rem/14);
  width: auto;
  min-width: calc(46rem/14);
}
:host .container .content {
  flex: 1 1 auto;
  padding: 0 calc(20rem/14);
}
:host .container .content .title {
  height: calc(22rem/14);
  line-height: calc(22rem/14);
  font-weight: bold;
  color: #50585C;
  color: var(--davinci-color-text-light, #50585C);
}
:host .container .content .description {
  height: calc(12rem/14);
  font-size: calc(12rem/14);
  line-height: calc(12rem/14);
  color: #2C3133;
  color: var(--davinci-color-text, #2C3133);
}
:host .container .actionIcon {
  flex: 0 0 auto;
  min-width: calc(24rem/14);
  padding: 0 1rem;
  fill: #007CC1;
  fill: var(--davinci-color-primary, #007CC1);
}
:host .container .actionIcon davinci-icon,
:host .container .actionIcon davinci-icon-ref {
  font-size: 1rem;
}
:host .container:hover, :host .container:active {
  background-color: #C5CACC;
  background-color: var(--davinci-color-outline-light, #C5CACC);
}

:host([disabled]) {
  pointer-events: none;
}
:host([disabled]) .container {
  background-color: #FBFCFC;
  background-color: var(--davinci-color-background-2, #FBFCFC);
}
:host([disabled]) .container .slotPlaceholder ::slotted(img) {
  opacity: 0.5;
}
:host([disabled]) .container .content .title, :host([disabled]) .container .content .description {
  color: #B1B8BC;
  color: var(--davinci-color-text-disabled, #B1B8BC);
}
:host([disabled]) .container .actionIcon {
  fill: #B1B8BC;
  fill: var(--davinci-color-text-disabled, #B1B8BC);
}

:host([hidden]) {
  display: none;
}`;
export { style };
